<template>
  <v-dialog
    v-model="show"
    width="500"
  >
    <elac-login @login="show = false" />
  </v-dialog>
</template>

<script>
import ElacLogin from '@/components/ElacLogin.vue';

export default {
  name: 'ElacLoginPopup',

  components: { ElacLogin },

  computed: {
    show: {
      get() {
        return this.$store.getters['auth/show'];
      },

      set(v) {
        this.$store.commit('auth/show', { show: v });
      },
    },
  },
};
</script>
